module.exports = __webpack_public_path__ + "static/media/FlorianGraf_sliderRight.84a5392c.svg";